import { render } from "./UserInfoSectionMenuSaihanCmp.vue?vue&type=template&id=744ebac2&scoped=true"
import script from "./UserInfoSectionMenuSaihanCmp.vue?vue&type=script&lang=js"
export * from "./UserInfoSectionMenuSaihanCmp.vue?vue&type=script&lang=js"

import "../css/UserInfoSectionSaihan.css?vue&type=style&index=0&id=744ebac2&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src991838332/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/splats-mypage-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-744ebac2"]])

export default __exports__